import { isNullOrUndefined } from '@/shared/helpers';
import { DateTime } from 'luxon';
import type { AssociationType } from './AssociationType';
import type User from './User';
import type {
    AssessmentPhotoType,
    AssessmentPhotoSubtype,
} from './TrailerPhotoAssessmentTypes';

export default class TrailerPhotos {
    trailerId: string;
    photos: Photo[];

    constructor(photos: Photo[] | null, trailerId: string) {
        if (isNullOrUndefined(photos)) this.photos = [];
        else this.photos = photos!;

        this.trailerId = trailerId;
    }
}

export class TrailerPhotosMeta {
    startDate: DateTime;
    association: AssociationType;
    driverDetails: User;
    hasDismissedModal: boolean;

    constructor(association: AssociationType, driverDetails: User) {
        this.association = association;
        this.driverDetails = driverDetails;
        this.startDate = DateTime.local().toUTC();
        this.hasDismissedModal = false;
    }
}

export class Photo {
    type: AssessmentPhotoType;
    subtype: AssessmentPhotoSubtype;
    photoName: string;

    constructor(
        type: AssessmentPhotoType,
        subtype: AssessmentPhotoSubtype,
        photoName: string
    ) {
        this.type = type;
        this.subtype = subtype;
        this.photoName = photoName;
    }
}
